
import React, { useState, useEffect } from "react";
import { Badge } from "@/components/ui/badge";

export const LogoText = () => {
  const [showEarlyAccess, setShowEarlyAccess] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    setShowEarlyAccess(false);
    
    const showEarlyAccessTimer = setTimeout(() => {
      setShowEarlyAccess(true);
      
      const backToFomoTimer = setTimeout(() => {
        setShowEarlyAccess(false);
        setHasAnimated(true);
      }, 2000);
      
      return () => clearTimeout(backToFomoTimer);
    }, 1500);
    
    return () => clearTimeout(showEarlyAccessTimer);
  }, []);

  const handleMouseEnter = () => {
    if (hasAnimated) {
      setShowEarlyAccess(true);
    }
  };

  const handleMouseLeave = () => {
    if (hasAnimated) {
      setShowEarlyAccess(false);
    }
  };

  return (
    <div 
      className="relative cursor-pointer min-w-[80px] h-[32px] flex items-center justify-center" 
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {!showEarlyAccess && (
        <span className="font-bold text-xl absolute inset-0 flex items-center justify-center transition-all duration-300">
          FOMO
        </span>
      )}
      
      {showEarlyAccess && (
        <div className="absolute inset-0 flex items-center justify-center">
          <Badge 
            variant="secondary" 
            className="
              bg-gradient-to-r from-[#7E69AB] to-[#9b87f5] 
              px-3 py-0.5 rounded-full shadow-md 
              border border-white/20
              text-xs font-medium whitespace-nowrap
              text-white/95 hover:text-white
              transition-all duration-300
              backdrop-blur-sm
              hover:shadow-lg hover:border-white/30
            "
          >
            Early Access
          </Badge>
        </div>
      )}
    </div>
  );
};
